import { ReactNode } from "react";
import { BrowserRouter } from "react-router-dom";

import AuthProvider from "./providers/auth";
import ThemeProvider from "./providers/theme";
export * from "./firebaseInit";

interface CoreProps {
  children: ReactNode;
}

export default function Core({ children }: CoreProps) {
  return (
    <AuthProvider>
      <ThemeProvider>
        <BrowserRouter>{children}</BrowserRouter>
      </ThemeProvider>
    </AuthProvider>
  );
}
